import React from 'react'
import { HeroPanel, DetailTilesContainer, EnvironmentTitle, BannerStatusTile, BannerTilesGroup } from 'view/shared/heroPanel'
import { Locale, Translation } from 'locale'
import { CollateralBasketDetail, CollateralBasketStatus, CollateralBasketType } from 'api'
import { groupBy } from 'lodash-es'

interface CollateralBasketHeroPanelProps {
  collateralBasketList: CollateralBasketDetail[]
  onTearout: () => void
}

export const CollateralBasketHeroPanel: React.FunctionComponent<CollateralBasketHeroPanelProps> = props => {
  const { collateralBasketList, onTearout } = props

  const collateralBasketByStatus = groupBy(collateralBasketList, basketDetail => basketDetail.collateralBasket.status)
  const activeCollateralBaskets = collateralBasketByStatus[CollateralBasketStatus.ACTIVE] || []
  const suspendedCollateralBaskets = collateralBasketByStatus[CollateralBasketStatus.SUSPENDED] || []

  const collateralBasketByType = groupBy(collateralBasketList, orgDetail => orgDetail.productSector?.basketType)
  const gcBespokeCollateralBaskets = collateralBasketByType[CollateralBasketType.GC_BESPOKE] || []
  const dbvCollateralBaskets = collateralBasketByType[CollateralBasketType.DBV] || []
  const euroclearCollateralBaskets = collateralBasketByType[CollateralBasketType.EUROCLEAR] || []

  return (
    <HeroPanel onTearout={onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'CollateralBasketHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_HERO_COLLATERAL_BASKETS)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_TOTAL)} label={collateralBasketList.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_ACTIVE)} label={activeCollateralBaskets.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_SUSPENDED)} label={suspendedCollateralBaskets.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_BASKET_TYPE_GC_BESPOKE)} label={gcBespokeCollateralBaskets.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_BASKET_TYPE_DBV)} label={dbvCollateralBaskets.length} />
          <BannerStatusTile title={Locale.translate(Translation.TC_BASKET_TYPE_EUROCLEAR)} label={euroclearCollateralBaskets.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}
